<template>
  <view-vote :key="this.$route.fullPath" />
</template>

<script>
import ViewVote from '@/components/vote/ViewVote';
export default {
  components: {
    ViewVote
  }
};
</script>
